import * as React from 'react';
import {Redirect, Route, Switch} from 'react-router'
import  Login  from './Routes/Login/Login';
import  Register  from './Routes/Register/Register';
import  Callback  from "src/components/Login/Callback"
import  {PrivateRoutes}  from './Routes/PrivateRoutes';


import './App.css';


class App extends React.Component {

    render() {
        return (
            <div className="explorer-layout App">
                {/*<Route component={ Header }/>*/}
                
                
                <div className="App-Content">
                    <Switch> 
                        <Route exact path="/" render={() => <Redirect to={'/login'} />}/>
                        <Route exact path="/login" component={ Login }/>
                        <Route exact path="/callback" component={ Callback }/>
                        <Route exact path="/register" component={ Register }/>
                        <Route component={PrivateRoutes} />

                    </Switch>
                </div>
            </div>
        );
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx